import React from 'react'
import { TertiaryButtonLight } from '../../../core/components/unilink/index'
import { getBreadcrumbsFromTopic } from '../../../core/components/breadcrumbs/BreadCrumbs'
import map from 'lodash/map'
import './searchresults.css'
import TopicCard from '../../../core/components/topic-card/TopicCard'

const renderESResults = (esResults, query) => (
  <div>
    {esResults.results.map(result => {
      const { parent, second_level_ancestor, second_level_ancestor_id } = result._source
      const breadcrumbTopics =
        parent !== second_level_ancestor
          ? [second_level_ancestor, parent]
          : [parent]
      const subjectColorId = second_level_ancestor_id

      const excludeTopics = ["Graveyard", "Algebra Revisited", "Sandbox Duplicates", "Reference: Number and Language in Math", "Suggest Missing Topics Here","What Is Linear Algebra?","Transformations in Depth", "Notes for Contributors", "Beyond High School Geometry", "Algebra Glossary"]
      const cleanResults = !excludeTopics.includes(breadcrumbTopics[0])
      const topicCard =  cleanResults  ?
      <TopicCard
          className="searchresults__card"
          title={result._source.rendered_title}
          description={result._source.description}
          id={result._source.id}
          slug={result._source.slug}
          breadcrumbTopics={breadcrumbTopics}
          key={result._source.id}
          subjectColorId={subjectColorId}
          query={query}
        /> : ''
      return (
        topicCard
      )
    })}
  </div>
)

const renderTrending = trendingTopics => (
  <div>
    {trendingTopics.map(result => {
      const breadcrumbs = getBreadcrumbsFromTopic(result)
      const breadcrumbTopics = map(
        breadcrumbs,
        t => t.renderedTitle
      )
      return (
        <TopicCard
          className="searchresults__card"
          title={result.renderedTitle}
          description={result.renderedDescription}
          id={result.id}
          slug={result.slug}
          breadcrumbTopics={breadcrumbTopics}
          subjectColorId={breadcrumbs[0].id}
          key={result.id}
        />
      )
    })}
  </div>
)

export const SearchResults = ({
  esResults,
  query,
  isFetching,
  didGetResults,
  activeFilters,
  trendingTopics,
  getTrendingTopics,
  hasMore,
  getNextPage,
  titles
}) => {

  // Fetching trending topics if they are not already in store
  if (!trendingTopics.length) {
    getTrendingTopics()
  }
  
  if (query.length || activeFilters.length) {
    return (
      <div className="searchresults">
        <h3 className="searchresults__header">
          <b>{esResults.total}</b> results for "{query.length === 0 &&
          activeFilters.length === 1
            ? activeFilters[0]
            : query}"
        </h3>
        <ul className="searchresults__list">
          {didGetResults ? renderESResults(esResults, query) : null}
          {didGetResults && hasMore
            ? (
              <TertiaryButtonLight
                onClick={getNextPage}
                className="searchresults__seemore"
              >
                {' '}
                See More{' '}
              </TertiaryButtonLight>
            )
            : didGetResults && esResults.total === 0
              ?  (
                <div className="searchresults__seemore--endoflist">
              No Results Found
                </div>
              )
              : (
                <div className="searchresults__seemore--endoflist">
              End of Results
                </div>
              )
          }
        </ul>
      </div>
    )
  } else {
    return (
      <div className="searchresults">
        <h3 className="searchresults__header">Trending Topics</h3>
        <ul className="searchresults__list">
          {renderTrending(trendingTopics)}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/domains/search/components/SearchResults.js